import { PureComponent, ReactNode } from 'react'
import * as styles from 'components/features/pfm/AccountBadge/AccountBadge.css'
import { CreditCardType } from 'interfaces/credit'
import { renderSnippet } from 'tangle-shared'
import { formatUSDate } from 'helpers/dateTimeHelpers'

export type AccountBadgeProps = {
  name: string
  cardNumber?: string | null
  cardType?: CreditCardType | null
  updatedAt?: string
  updatedAtPrefix?: 'on' | 'as of'
  tooltipChild?: ReactNode
}

class AccountBadge extends PureComponent<AccountBadgeProps, {}> {
  static defaultProps = {
    updatedAtPrefix: 'as of',
  }

  get formattedCard (): string {
    const { cardType, cardNumber } = this.props

    if (cardNumber) {
      if (!cardType || cardType.toLowerCase() === 'unknown') {
        return `Ending in: ${ cardNumber }`
      } else {
        return `${ cardType.toUpperCase() }-${ cardNumber }`
      }
    }

    return ''
  }

  render () {
    const { name, tooltipChild } = this.props

    const dotWrapperChild = renderSnippet(
      ({ children }) => (
        <div className={ styles.tooltipIconWrapper }>
          { children }
        </div>
      ),
      tooltipChild
    )

    return (
      <div className={ styles.accountBadge }>
        <div className={ styles.accountName }>
          <div className={ styles.accountNameInner }>
            { dotWrapperChild }
            { name }
          </div>
        </div>
        { this.renderAccountDetails() }
      </div>
    )
  }

  renderAccountDetails = () => {
    const { updatedAt, updatedAtPrefix } = this.props
    const { formattedCard } = this

    const formattedCardChild = renderSnippet(
      ({ children }) => (
        <span>
          <span className={ styles.cardDetails }>{ children }</span>
        </span>
      ),
      formattedCard,
    )

    const updatedAtChild = renderSnippet(
      ({ children }) => (
        <span>{ updatedAtPrefix } { children }</span>
      ),
      updatedAt ? formatUSDate(updatedAt) : null
    )

    const dividerChild = formattedCardChild && updatedAtChild ? '|' : null

    return (
      <div className={ styles.details }>
        { formattedCardChild } { dividerChild } { updatedAtChild }
      </div>
    )
  }
}

export default AccountBadge
